// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__09LoT","img":"Header_img__6gX5a","logo":"Header_logo__iqQEb","nav":"Header_nav__9Mtck"};